// HowToUse.jsx
import { useState } from "react";
import {
  Container,
  Row,
  Col,
  Accordion,
  Card,
  Image,
  Ratio,
  Modal,
} from "react-bootstrap";

// Helper to create unique, stable placeholder URLs (16:9)
const PH = (seed, w = 1200, h = 675) =>
  `https://picsum.photos/seed/${encodeURIComponent(seed)}/${w}/${h}`;

import imgIDLBAY from "../../assets/idlbay.png"
import img0 from "../../assets/0_add_location_modal.png"
import img1 from "../../assets/1_reg.png"
import img2 from "../../assets/2_login.png"
import img3 from "../../assets/3_dashboard.png"
import img4 from "../../assets/4_dashboard_search.png"
import img5 from "../../assets/5_add_location.png"
import img6 from "../../assets/6_add_location.png"
import img7 from "../../assets/7_add_employee.png"
import img8 from "../../assets/8_add_employee_details.png"
import img9 from "../../assets/9_view_approved_details.png"
import img10 from "../../assets/10_view_unapproved_details.png"
import img11 from "../../assets/11_active_inactive.png"
import img12 from "../../assets/12_assign_pay_period.png"
import img012 from "../../assets/012_assign_pay_period_modal.png"
import img13 from "../../assets/13_set_salary.png"
import img113 from "../../assets/113_set_salary.png"
import img213 from "../../assets/213_set_overtime.png"
import img14 from "../../assets/14_add_hours_pay_salary.png"
import img15 from "../../assets/15_assign_employee_location.png"
import img115 from "../../assets/115_location_modal.png"
import img116 from "../../assets/116_location_modal.png"
import img16 from "../../assets/16_edit_employee_location.png"
import img17 from "../../assets/17_leave_management.png"
import img18 from "../../assets/18_leave_management_modal.png"
import img19 from "../../assets/19_generate_payslip.png"
import img20 from "../../assets/20_generate_payslip_modal.png"
import img21 from "../../assets/21_payslip_configuration.png"
import img22 from "../../assets/22_payslip_records.png"
import img23 from "../../assets/23_payslip_configurator.png"
import img24 from "../../assets/24_payslip_configurator_modal.png"
import img25 from "../../assets/25_revenue.png"
import img26 from "../../assets/26_admin_management.png"
import img27 from "../../assets/27_user_authentication.png"

// ---------------------- Component code ----------------------
const Step = ({ idx, title, text, img, onImageClick }) => (
  <Card className="mb-3 border-0 shadow-sm">
    <Card.Body>
      <Row className="g-3 align-items-center">
        <Col md={7} xs={12}>
          <div>
            {title ? (
              <h5 className="mb-1">
                {/* {idx != null ? `${idx}. ` : ""} */}
                {title}
              </h5>
            ) : null}
            {text ? <p className="mb-0 fs-15">{text}</p> : null}
          </div>
        </Col>

        {img ? (
          <Col md={5} xs={12}>
            <Ratio aspectRatio="16x9">
              <Image
                src={img}
                alt={title || `Step ${idx}`}
                className="rounded"
                fluid
                role="button"
                style={{ cursor: "pointer" }}
                onClick={() => onImageClick(img, title || `Step ${idx}`)}
              />
            </Ratio>
          </Col>
        ) : null}
      </Row>
    </Card.Body>
  </Card>
);

const SECTIONS = [
  // ADMIN REGISTRATION
  {
    id: "admin-registration",
    title: "Admin Registration & Login",
    steps: [
      {
        title: "Register",
        text: "To create an admin account, enter your complete name in the Full Name field, provide a valid email address for communication, and enter your 10-digit mobile number. Create a password with a minimum of six characters and use the “Show Password” option if you wish to view your password while typing. Only accounts with unique email and mobile combinations can be registered.",
        img: img1,
      },
      {
        title: "Log in",
        text: "Once registered, you can log in using your Mobile Number and Password.",
        img: img2,
      },
    ],
  },

  // DASHBOARD
  {
    id: "dashboard",
    title: "Payroll Dashboard",
    steps: [
      {
        title: "Dashboard",
        text: "The dashboard provides a clear overview of the employee attendance summary for the current date. It displays the total number of employees, along with a quick breakdown of how many are present, absent, or on leave for the day. The main table lists detailed employee information, including  Date, Employee ID, Name, Mobile Number, Email, Location, Shift, and Status. Each record helps the admin easily identify attendance patterns and manage workforce activity effectively.",
        img: img3,
      },
      {
        text: "A search bar is available to quickly find employees by name, ID, or other details. You can also use filters such as Location, Shift, and Status to narrow down the displayed records.",
        img: img4,
      },
    ],
  },

  // MANAGE LOCATIONS
  {
    id: "manage-locations",
    title: "Add Locations",
    steps: [
      {
        text: "The Add Location page allows the admin to create and manage office or branch locations along with their corresponding work shifts. This section is designed for flexibility and precision, enabling the admin to define exact working areas and timings for employees.",
        img: img5,
      },
      {
        text: "A map interface is integrated into the form, allowing admins to pinpoint the location visually. This modal will open while clicking the Add Location button",
        img: img0,
      },
      {
        text: "Alternatively, the admin can use the Location Search input to find and select a place. Once a location is selected, the Location Name, Latitude, and Longitude fields are automatically filled in based on the chosen map point.Below the location details, admins can add Shifts for that location. Each shift includes Shift Name, Start Time, End Time (automatically calculated), Working Hours (automatically set based on start and end times, minus one hour)",
        img: img6,
      },
    ],
  },

  // USER MANAGEMENT
{
  id: "employee-management",
  title: "Manage Employee",
  steps: [
    {
      title: "Add Employee",
      text:
        "Create new employee profiles and maintain existing ones. Enter basic details (Full Name, Employee ID, Email, Mobile, etc.), edit when needed, or delete outdated records. Use the Search bar and Date filter to quickly locate employees. Export the filtered list to Excel or PDF for reporting.",
      img: img7,
    },
    {
      title: "Add Employee Details",
      text:
        "Capture complete employee information: personal details, educational history, certificates, document images, and employment details. You can add, edit, and update these records anytime to keep profiles accurate and audit-ready.",
      img: img8,
    },
    {
      title: "Emplee Details Approved",
      text:
        "Browse all approved employees and view their full profiles in one place. This includes core details and attached documents for quick verification.",
      img: img9,
    },
    {
      title: "Emplee Details Unapproved",
      text:
        "See employees who registered but are not yet approved. Open each record to review submitted details and documents, then approve to grant access or keep pending if information is incomplete.",
      img: img10,
    },
    {
      title: "Active / Inactive",
      text:
        "Control login access by setting employee status to Active or Inactive. Use search and date filters to find records quickly. Export the current (filtered) view to Excel or PDF for sharing or archiving.",
      img: img11,
    },
  ],
}
,


  // SALARY MANAGEMENT
{
  id: "salary-management",
  title: "Manage Salary",
  steps: [
    {
      title: "Assign Pay Period",
      text:
        "View each employee’s Full Name, Email, Mobile Number, Employee ID, Joining Date, Salary, and Overtime Salary. Click Edit to open a modal and configure the pay schedule.",
      img: img12,
    },
    {
      text:
        "Set Period Type (payouts per month): use 1 for a single monthly payout, or 2 for two payouts per month. For a once-per-month schedule, set the Pay Date (1–31) on which salary is paid, then save.",
      img: img012,
    },
    {
      title: "Set Salary & Overtime",
      text:
        "See Employee Details, Contact, Email, Location, Shift, Current Salary, and Overtime Rate. Click set salary to set salary and for overtime salary click set overtime to open the modal and set or update salary.",
      img: img13,
    },
    {
      text:
        "Choose salary type (Hourly or Monthly), enter the rate, and set an Effective Date. Save to apply changes.",
      img: img113,
    },
    {
      text:
        "For Overtime, set the hourly OT rate and its Effective Date. Save to apply changes.",
      img: img213,
    },
    {
      title: "Add Hours & Pay Salary",
      text:
        "Manually record the hours an employee worked and pay their salary. Use search and filters to find the employee, input the regular and (if applicable) overtime hours for the period, and the system computes the payable amount from current rates. Use Pay/Confirm to finalize the payment; already-paid rows are locked or hidden.",
      img: img14,
    },
  ],
},

  {
    id: "manage-users-locations",
    title: "Manage Employee Locations",
    steps: [
      {
        title: "Assign Employee Location",
        text: "The Assign Employee Location page allows the admin to view and manage employee location assignments efficiently. The table displays the following columns Full Name, Mobile Number, Employee ID, Location Status, and Actions. Each employee record includes an Assign Location. A Bulk Assign button that allows the admin to assign a single location and shift to multiple unassigned employees simultaneously.",
        img: img15,
      },
      {
        text: "When assigning, a modal window appears. This modal includes a searchable dropdown input to choose the location. Once a location is selected, the Shift Dropdown automatically updates to display only the shifts available for that specific location. The admin can then select the desired shift and click Assign to confirm the assignment.",
        img: img115,
      },
      {
        title: "Edit Employee Location",
        text: "The Edit Employee Location page allows the admin to view and manage employee location assignments efficiently. The table displays the following columns Full Name, Mobile Number, Employee ID, Location Status, and Actions. Each employee record includes an Edit Location. A Bulk Assign button that allows the admin to assign a single location and shift to multiple unassigned employees simultaneously.",
        img: img16,
      },
      {
        text: "When editing, a modal window appears. This modal includes a searchable dropdown input to choose the location. Once a location is selected, the Shift Dropdown automatically updates to display only the shifts available for that specific location. The admin can then select the desired shift and click Assign to confirm the assignment.",
        img: img116,
      },
    ],
  },
  // LEAVE REQUESTS
  {
    id: "leave-requests",
    title: "Leave Management",
    steps: [
      {
        text: "The Leave Requests page is designed for managing all employee leave applications in one place. It provides a complete overview of every leave request submitted through the employee application, allowing the admin to review, approve, or reject them efficiently.The leave requests are displayed in a detailed table format with the following columns - Employee, Mobile, Leave Date(s), Leave Type, Reason, Applied On, Status, and Actions.",
        img: img17,
      },
      {
        text: "By clicking the Manage/Edit button in the Actions column, a modal opens that provides full leave details. If the leave type is Multiple, the modal displays additional action buttons such as: Approve All – to approve all requested leave days at once. Reject All – to reject all days in a single action. Edit – to modify and process individual leave days separately (used for Partial Processing). Cancel – to close the modal without making changes.",
        img: img18,
      },
    ],
  },

  // PAYSLIPS
  {
    id: "payslips",
    title: "Payslip Management",
    steps: [
    {
      title: "Generate Payslips",
      text:
        "Generate, review, and manage payslips in one place. Use search, filters, and exports to keep payroll fast and accurate.",
      img: img19,
    },
    {
      text:
        "Select an employee, verify salary components (basic, HRA, allowances, deductions), then click Generate Payslip. The system auto-calculates and creates a formatted slip instantly.",
      img: img20,
    },
      {
        title: "Payslip Configuration",
        text: "Add company info. Set company Name, Address, and Logo. Maintain departments, designations, and employment types for branches and edit delete the payslip configuration.",
        img: img21,
      },
      {
        title: "Payslip Record",
        text: "View, download, print, edit, or delete and re-generate payslips if corrections are needed. Browse historical records by employee and month and open View Detail for the full breakdown.",
        img: img22,
      },
    {
    title: "Payroll Configurator",
    text:
        "On the Payroll Configurator page, you can view and update which earnings and deductions should appear on an employee’s payslip. By clicking the Edit button in the Actions column, you can modify the earnings and deductions sections.",
    img: img23,
    },
    {
    text:
        "Select the items that should be shown and click the Save Changes button to apply your updates. You can edit these settings anytime; changes will automatically apply to future calculations.",
    img: img24,
    }
    ],
  },
{
  id: "settings",
  title: "Settings",
  steps: [
    {
      title: "Revenue",
      text:
        "This page shows how much has been paid as regular salary and overtime salary for the selected period. Summary cards display overall totals, and the table lists employee/payslip-wise amounts. Use filters to refine results; by default, the current month is shown. You can export the filtered data to PDF or Excel.",
      img: img25, 
    },
    {
      title: "Admin Management",
      text:
        "View all admins with details such as Full Name, Email, Mobile, Role, Status, Date of Joining, and Actions. Update Role and Status or delete admins where allowed. Note: Admins cannot edit Super Admin accounts. Search, filters, and PDF/Excel export are available for easier management.",
      img: img26, 
    },
    {
      title: "User Authentication",
      text:
        "Super Admins can manage page-level permissions for each admin. Click Manage Permission to open a modal and enable or disable access to specific pages or features. Admins cannot view pages without assigned permission, ensuring secure, role-based access control.",
      img: img27, 
    },
  ],
}

];

const HowToUse = () => {
  const [imgModal, setImgModal] = useState({ show: false, src: "", alt: "" });
  const openImage = (src, alt) => setImgModal({ show: true, src, alt });
  const closeImage = () => setImgModal({ show: false, src: "", alt: "" });

  const [activeKey, setActiveKey] = useState("admin-registration");

  const handleAccordionSelect = (eventKey) => {
    setActiveKey((prev) => (prev === eventKey ? null : eventKey));
  };

  return (
    <div className="bg-light">
      <Container fluid className="py-4">
        {/* Hero */}
        <Card className="border-0 shadow-sm mb-4">
          <Card.Body className="p-4 p-md-5">
            <Row className="align-items-center g-4">
              <Col md={8}>
                <h1 className="display-6 mb-3">Payroll Admin</h1>
                <p className="lead mb-3">
                  Welcome to the Payroll Admin Panel! This section
                  explains each sidebar section in detail with clear
                  step-by-step instructions. Use this guide to understand every
                  module and its features
                </p>
              </Col>
              <Col md={4}>
                <Ratio aspectRatio="16x9">
                  <Image
                    src={imgIDLBAY}
                    alt="Admin Guide"
                    className="rounded"
                    fluid
                    role="button"
                    style={{ cursor: "pointer", backgroundPosition: "contain" }}
                    onClick={() => openImage(imgIDLBAY)}
                  />
                </Ratio>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Row>
          {/* Main Content */}
          <Col>
            <Accordion activeKey={activeKey} onSelect={handleAccordionSelect}>
              {SECTIONS.map((section) => (
                <Accordion.Item
                  eventKey={section.id}
                  key={section.id}
                  id={section.id}
                >
                  <Accordion.Header>
                    <h5>{section.title}</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                    {section.blurb ? <p className="">{section.blurb}</p> : null}

                    {section.steps?.length ? (
                      <div>
                        {section.steps.map((st, idx) => (
                          <Step
                            key={`${section.id}-step-${idx}`}
                            idx={idx + 1}
                            title={st.title}
                            text={st.text}
                            img={st.img}
                            onImageClick={openImage}
                          />
                        ))}
                      </div>
                    ) : null}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>

      {/* Shared Image Modal */}
      <Modal show={imgModal.show} onHide={closeImage} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Image
            src={imgModal.src}
            alt={imgModal.alt || "Preview"}
            fluid
            className="rounded"
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default HowToUse;
